import React from 'react';

import { FeaturesBlock } from '@/app/_components/FeaturesBlock';
import { FeaturesBlockProps } from './types';

import classes from './index.module.scss';

export const FeaturesBlockGraphQL: React.FC<FeaturesBlockProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <FeaturesBlock featuresBlock={props} />
    </div>
  );
};

export default FeaturesBlockGraphQL;
